// 组件对象，大写
import inputSelectOfModalTable from './inputSelectOfModalTable.vue'
export default inputSelectOfModalTable
